import React from 'react';
import Checkbox from 'components/Checkbox';
import Radio from 'components/Radio';
import RippleWrapper from 'components/RippleWrapper';
import MenuItemPrice from 'components.special/MenuItemPrice';
import * as ServiceTypeConstants from 'data/serviceTypeConstant';
import withOrderService from 'hocs/withOrderService';
import ValidatorElement from './Shared/ValidatorElement';

const TakeAwayPanelInner = ({ cart, orderSessionData, data, menuItem, onValueChange, forwardedRef }) => {
    const { orderServiceType } = orderSessionData;
    const { menuItemGuid, serviceType } = data;
    const { takeAwayItem } = menuItem;

    let disabled = false;
    if (takeAwayItem) {
        disabled = takeAwayItem.isOutOfStock;
    }

    const handleServiceTypeChange = (checked) => {
        onValueChange({
            serviceType: checked ? ServiceTypeConstants.TakeAway : ServiceTypeConstants.DineIn,
            takeAwayItem: checked && takeAwayItem ? cart.buildCartItemTakeAwayItem(takeAwayItem) : null
        });
    };

    return (
        <div className="apps-ui-menu-item-component-customize-panel d-flex flex-column p-3" ref={forwardedRef}>
            <RippleWrapper
                className="d-flex align-items-center"
                style={{ opacity: disabled ? 0.5 : undefined }}
                htmlFor={data.menuItemGuid}
            >
                <div className="flex-grow-1 d-flex flex-column fs-5">
                    <span className="fw-bold">Takeaway</span>

                    {takeAwayItem && <span className="text-muted fs-6">{takeAwayItem.name}</span>}

                    <MenuItemPrice
                        as="span"
                        className="text-muted fs-5"
                        value={takeAwayItem ? takeAwayItem.price : 0}
                        prefix="+"
                        prefixSmallFont
                        isCurrencyFormat
                        disabled={disabled}
                    />

                    {disabled && (
                        <span className="fw-bold mb-1" style={{ color: 'var(--primary-dark)' }}>
                            Not Available
                        </span>
                    )}
                </div>

                <div className="col-1 d-inline-flex align-items-center justify-content-center">
                    {orderServiceType === ServiceTypeConstants.DineIn ? (
                        <Checkbox
                            value={menuItemGuid}
                            checked={serviceType === ServiceTypeConstants.TakeAway}
                            disabled={disabled}
                            handleChange={handleServiceTypeChange}
                        />
                    ) : (
                        <Radio
                            value={menuItemGuid}
                            groupValue="take-away-list"
                            checked={serviceType === ServiceTypeConstants.TakeAway && !disabled}
                            disabled={disabled}
                            handleChange={handleServiceTypeChange}
                        />
                    )}
                </div>
            </RippleWrapper>

            <ValidatorElement message="Please select one takeaway item." />
        </div>
    );
};

const TakeAwayPanelWithHocs = withOrderService(TakeAwayPanelInner);

const TakeAwayPanel = React.forwardRef((props, ref) => <TakeAwayPanelWithHocs {...props} forwardedRef={ref} />);

export default TakeAwayPanel;
